import { render, staticRenderFns } from "./SearchesListModal.vue?vue&type=template&id=05014fe7&scoped=true&"
import script from "./SearchesListModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchesListModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05014fe7",
  null
  
)

export default component.exports